'use strict';

var scrollAnimate = require('base/components/scrollAnimate');
var kleberEmailValidation = require('../../js/kleber/kleberEmailValidation');
var cookieHelper = require('../../js/components/cookie');

/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked for email sign-up
 */
function displayMessage(data, button) {
    $.spinner().stop();
    var status;
    if (data.success) {
        $('#email-alert-address').val('');
        status = 'alert-success';
    } else {
        status = 'alert-danger';
    }

    if ($('.email-signup-message').length === 0) {
        $('body').append(
           '<div class="email-signup-message"></div>'
        );
    }
    $('.email-signup-message')
        .append('<div class="email-signup-alert text-center ' + status + '">' + data.msg + '</div>');

    setTimeout(function () {
        $('.email-signup-message').remove();
        button.removeAttr('disabled');
    }, 3000);
}

module.exports = function () {
    $('.back-to-top').click(function () {
        scrollAnimate();
    });

    $('form#email-alert-signup').submit(function (e) {
        e.preventDefault();
        e.stopPropagation();
        var form = $(this);
        var url = form.attr('action');
        var button = $('.button.subscribe-email');
        var emailId = $('#email-alert-address').val();
        var emailField = $('input[name=hpEmailSignUp]');
        if (!form[0].checkValidity()) {
            return false;
        }
        button.attr('disabled', true);
        $.spinner().start();
        kleberEmailValidation.isValidEmail(emailField).then(isValid => {
            if (isValid) {
                $.ajax({
                    url: url,
                    type: 'post',
                    dataType: 'json',
                    data: {
                        emailId: emailId
                    },
                    success: function (data) {
                        displayMessage(data, button);
                    },
                    error: function (err) {
                        displayMessage(err, button);
                    }
                });
            }
            $.spinner().stop();
            button.removeAttr('disabled');
        });
        return false;
    });

    (function () {
        function getUrlParameter(sParam) {
            var sPageURL = window.location.search.substring(1),
                sURLVariables = sPageURL.split('&'),
                sParameterName,
                i;

            for (i = 0; i < sURLVariables.length; i++) {
                sParameterName = sURLVariables[i].split('=');

                if (sParameterName[0] === sParam) {
                    return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
                }
            }
            return false;
        }
        var country = getUrlParameter('country');
        var currency = getUrlParameter('currency');
        var code = getUrlParameter('code');
        if (country && currency) {
            cookieHelper.setCookie('preferredCountry', country, 7);
            cookieHelper.setCookie('preferredCurrency', currency, 7);
            cookieHelper.setCookie('code', code, 7);
            cookieHelper.setCookie('countryPopupShown', 'true', 7);

            var destination = new URL(window.location.href);
            ['country', 'currency', 'code', 'countryPopupShown'].forEach(function (key) {
                destination.searchParams.delete(key);
            });
            var cleanUrl = destination.toString();
            window.history.replaceState({}, document.title, cleanUrl);
            window.location = cleanUrl;
        }
    })();

    $(document).ready(function () {
        if (window.cookiehub) {
            var cpm = {};
            window.cookiehub.load(cpm);
        }
        /**
         * CookieHub Consent Mode Integration
         * Fires when a user accepts/rejects cookies in the CookieHub banner.
         */
       (function() {
            var isCookieHubEnabled = $('.cookie-value').attr('data-cookiehub-enabled');
            if(isCookieHubEnabled === 'true') {
                var marketingConsent = window.cookiehub.hasConsented('marketing');
                $.ajax({
                    url: window.updateTrackingConsent,
                    type: 'POST',
                    data: {
                        trackingAllowed: marketingConsent
                    },
                    success: function () {
                        window.sfccTrackingAllowed = marketingConsent;
                    }
                });
           }
        })();

        // Open modal and set local storage when globe button from header is clicked
        $('#locale-toggle').on('click', function () {
            $('#countryCurrencyLanguageModal').modal('show');
            $('#countryCurrencyLanguageModal .modal-header .close'). removeClass('hidden');
        });
        
        function showShippingCountryPopup() {
            var hasTrackingParam = cookieHelper.hasTrackingParams();
            if ($('.js-header-main .location').length > 0) {
                var countrySwitcherEnabled = $('.js-header-main .location').data('enable-country-switcher');
                var url = window.location.href;
                if (!countrySwitcherEnabled) {
                    cookieHelper.setDefaultPreferredCookie();
                    return;
                }
                if(hasTrackingParam){
                    cookieHelper.setDefaultPreferredCookie();
                }
            }
            // For not showing country switcher in toolKit
            var isToolkit = false;
            try {
                isToolkit = !!window.parent.document.querySelector('.sf-toolkit-storefront');
            } catch (e) {}
            var preferredCountry =  cookieHelper.getCookie('preferredCountry');
            var popupShown = cookieHelper.getCookie('countryPopupShown');
            var currentLocale = $('body').data('locale');
            var cookieLocale = cookieHelper.getCookie('code');
            if ((!popupShown && !isToolkit && !hasTrackingParam) ||  !preferredCountry || (cookieLocale && cookieLocale !== currentLocale)) {
                $('#countryCurrencyLanguageModal').modal('show');
            } else {
                $('#countryCurrencyLanguageModal').modal('hide');
                $('#countryCurrencyLanguageModal .modal-header .close'). removeClass('hidden');
            }
        }
        
        function isCookieHubSet() {
            return document.cookie.indexOf('cookiehub=') !== -1;
        }

        function waitForCookieHubCookie(interval = 100) {
            const check = setInterval(() => {
                if (isCookieHubSet()) {
                    clearInterval(check);
                    showShippingCountryPopup();
                }
            }, interval);
        }
        var isCookieHubEnabled = $('.cookie-value').data('cookiehub-enabled');
        if(!isCookieHubEnabled) {
            var cookiePolicyAccepted = window.localStorage.getItem('cookiePolicyAccepted');
            // For not showing country switcher in toolKit
            var isToolkit = false;
            try {
                isToolkit = !!window.parent.document.querySelector('.sf-toolkit-storefront');
            } catch (e) {}
            if (cookiePolicyAccepted && !isToolkit) {
                showShippingCountryPopup();
            }
        } else {
            waitForCookieHubCookie(100);
        }

        if (window.location.hash === '#register') {
            $('a[href="#register"]').tab('show');
        }
    });
};

